<a class={{btnClass}} (click)="clickBtn()">
    <div  *ngIf="icon && iconPosition === 'left'" class="flex items-center" [class]="iconContentClass"
    [ngClass]="{'border-r mr-8': type !== 'ghost'}">
      <div class="mr-8 overflow-hidden">
        <fun-icon [name]="icon" [style]="iconClass"></fun-icon>
      </div>
    </div>

    <div [class]="textClass">{{title}}</div>
    <div *ngIf="((icon !== 'menu') && (icon !== 'x')) && (iconPosition === 'right')" [class]="iconContentClass"
    [ngClass]="{'border-l': type !== 'ghost'}">
      <div class="ml-8 overflow-hidden">
         <fun-icon [name]="icon" [style]="iconClass"></fun-icon>
      </div>
    </div>

    <div *ngIf="((icon === 'menu') || (icon === 'x')) && (iconPosition === 'right')" [class]="iconContentClass">
      <div class="overflow-hidden">
         <fun-icon [name]="icon" [style]="iconClass"></fun-icon>
      </div>
    </div>
</a>